import React from 'react'
import { UserManagementSupplierStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Spinner,
  Input,
} from '../../components'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING } from '../../helpers'
import { store } from 'store'
import { usermanageController } from '../../apiService'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { isEmpty } from 'lodash'
import {
  dateMonDayYearTime,
  formatNumberWithComma,
} from '../../helpers/functions/format'

class UserManagementSupplier extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      options: [
        { value: 'All', label: 'All', id: 5 },
        { value: 'Admin', label: 'Admin', id: 5 },
      ],
      isSortBy: [
        { name: 'id', value: undefined },
        { name: 'name', value: undefined },
      ],
      modals: [
        // { name: 'history', isOpen: false },
        { name: 'delete', isOpen: false },
      ],
      isLoading: false,
      adminDetail: {
        adminId: null,
        adminName: '',
        typemodal: '',
      },
      selectStatus: 5,
      searchPage: 1,
      activePage: 1,
      searchKeyWord: '',
      orderBy: null,
      sortFiedName: null,
      responseGetSupplier: {
        limit: null,
        next_page: null,
        offset: null,
        page: null,
        prev_page: null,
        records: [],
        total_page: null,
        total_record: null,
      },
      listSupplierUsermanagement: [],
    }
  }

  componentDidMount() {
    this.fetchSupplierList()
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.user) {
      this.fetchSupplierList()
    }
  }

  setLoading = (status = false) => {
    this.setState({ isLoading: status })
  }

  fetchSupplierList = async () => {
    try {
      const { user } = store.getState()
      this.setLoading(true)
      if (user && user.role) {
        const params = {
          role_id: [this.state.selectStatus],
          keyword: this.state.searchKeyWord,
          page: this.state.activePage,
          sort_name: this.state.sortFiedName,
          sort_by: this.state.orderBy,
        }
        const res = await usermanageController().getListSupplier(params)
        this.setState({
          listSupplierUsermanagement: res.records,
          responseGetSupplier: res,
        })
        this.setLoading(false)
      }
    } catch (error) {
      throw new Error(error)
    }
  }

  onPageChange = pageNumber => {
    this.setState(
      prevState => {
        return { ...prevState, activePage: pageNumber }
      },
      () => {
        this.fetchSupplierList()
      }
    )
  }

  onInputChange = event => {
    this.setState({ searchKeyWord: event.target.value })
  }

  findSortBy = evt => {
    let sortBy = ''
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        sortBy = 'asc'
      } else if (column.name === evt && column.value == 'asc') {
        sortBy = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        sortBy = 'asc'
      }
      return sortBy
    })
    return sortBy
  }

  toggleSort = evt => {
    const orderBy = this.findSortBy(evt)
    const sortFiedName = evt
    this.setState(
      prevState => {
        const isSortBy = prevState.isSortBy.map(column => ({
          ...column,
          value:
            column.name === evt
              ? column.value !== undefined
                ? column.value === 'asc'
                  ? 'desc'
                  : 'asc'
                : 'asc'
              : undefined,
        }))
        return {
          ...prevState,
          isSortBy,
          orderBy,
          sortFiedName,
        }
      },
      () => {
        this.fetchSupplierList()
      }
    )
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  searchUsermanagement = () => {
    try {
      this.fetchSupplierList()
    } catch (error) {
      throw new Error(error)
    }
  }

  onEnter = event => {
    if (event.key === 'Enter' && event.keyCode === 13) {
      this.fetchSupplierList()
    }
  }

  onSelectStatus = StatusId => {
    this.setState({ selectStatus: StatusId }, () => {
      this.fetchSupplierList()
    })
  }

  toggleModal = (evt, adminId, adminName) => {
    this.setState(prevState => ({
      ...prevState,
      modals: prevState.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === evt ? !modal.isOpen : false,
      })),
    }))
    if (adminId && adminName) {
      this.setState({
        adminDetail: {
          adminId,
          adminName,
          typemodal: evt,
        },
      })
    }
  }

  deleteSupplierById = async () => {
    const { typemodal, adminId, adminName } = this.state.adminDetail
    try {
      const res = await usermanageController().deleteSupplierById(adminId)
      if (res.status === 'DeleteSuccess') {
        this.fetchSupplierList()
        toast.success('User was Deleted')
      }
      this.toggleModal(typemodal, adminId, adminName)
    } catch (error) {
      this.toggleModal(typemodal, adminId, adminName)
      toast.error('Can not delete User')
      throw new Error(error)
    }
  }

  checkTypeModal = async () => {
    const { typemodal, adminId } = this.state.adminDetail
    if (typemodal && adminId) {
      if (typemodal === 'delete') {
        this.deleteSupplierById(adminId)
      }
    }
  }

  renderListAdmin = (listAdminData = []) => {
    return listAdminData.map(adminData => this.renderDetail(adminData))
  }

  renderDetail = (
    adminData = {
      code: null,
      id: null,
      full_name: '',
      email: '',
      status: '',
      role: null,
      create_at: null,
    }
  ) => {
    return (
      <Table.TR>
        <Table.TD className="id">{adminData.code}</Table.TD>
        <Table.TD className="name">{adminData.full_name}</Table.TD>
        <Table.TD className="email">{adminData.email}</Table.TD>
        <Table.TD className="status">
          <p
            className={
              adminData.status === 1 ? 'active-status' : 'inactive-status'
            }
          >
            {adminData.status === 1 ? 'Active' : 'Inactive'}
          </p>
        </Table.TD>
        <Table.TD className="role">Admin</Table.TD>
        <Table.TD className="created-date">
          {dateMonDayYearTime(adminData.created_at)}
        </Table.TD>
        <Table.TD className="actions">
          <Section>
            <Button
              className="link"
              onClick={() => {
                this.props.history.push({
                  pathname:
                    ROUTE_PATH.USER_EDIT_FORM_SUPPLIER.PATH +
                    `:` +
                    adminData.id,
                })
              }}
            >
              <Image
                className="edit-icon"
                src={ICONS['icon-edit.svg']}
                alt="edit"
              />
            </Button>

            <Button
              className="link"
              onClick={() =>
                this.toggleModal('delete', adminData.id, adminData.full_name)
              }
            >
              <Image
                className="delete-icon"
                src={ICONS['icon-trash.svg']}
                alt="delete"
              />
            </Button>
          </Section>
        </Table.TD>
      </Table.TR>
    )
  }
  render() {
    const {
      options,
      modals,
      listSupplierUsermanagement,
      responseGetSupplier,
    } = this.state
    return (
      <React.Fragment>
        <UserManagementSupplierStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_user_management"
                  src={ICONS['icon-user-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_user_management" className="title">
                  {STRING.USER_MANAGEMENT}
                </Section>

                <Section
                  id="page_breadcrumb_user_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.USER_MANAGEMENT}</span>
                  </Button>
                </Section>
              </Section>
            </Section>

            <Section className="page-button">
              {/* <Button
                className="page-button"
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.USER_DETAIL_FORM_ADMIN.LINK
                  )
                }}
              >
                <Image src={ICONS['icon-add-circular.svg']} alt="add icon" />
                Create User
              </Button> */}
              <Button
                className="page-button"
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.USER_DETAIL_FORM_SUPPLIER.LINK
                  )
                }}
              >
                {/* <Image src={ICONS['icon-add-circular.svg']} alt="add icon" /> */}
                Create User
              </Button>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  onClickSearchIcon={() => this.searchUsermanagement()}
                  id="filter_search_input"
                  placeholder="ID, Name"
                  onChange={this.onInputChange}
                  value={this.state.searchKeyWord}
                  onKeyDown={this.onEnter}
                />

                <SelectBox
                  id="active_status_filter"
                  className="table-filter all-status"
                  options={options}
                  placeholder="ALL"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event => {
                    this.onSelectStatus(event.id)
                  }}
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="user split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH
                        className="id"
                        id="id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('id')}
                        onClick={() => this.toggleSort('id')}
                      >
                        ID
                      </Table.TH>

                      <Table.TH
                        className="name"
                        id="name_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('name')}
                        onClick={() => this.toggleSort('name')}
                      >
                        NAME
                      </Table.TH>

                      <Table.TH className="email" id="email_header">
                        EMAIL
                      </Table.TH>

                      <Table.TH className="status" id="status_header">
                        STATUS
                      </Table.TH>

                      <Table.TH className="role" id="role_header">
                        ROLE
                      </Table.TH>

                      <Table.TH
                        className="created-date"
                        id="created_date_header"
                      >
                        CREATED DATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    {this.state.isLoading ? (
                      <Spinner />
                    ) : (
                      this.renderListAdmin(listSupplierUsermanagement)
                    )}
                  </Table.TBODY>
                  {isEmpty(listSupplierUsermanagement) && (
                    <Section className="no-result-found">
                      <Image
                        src={ICONS['icon-ssr.png']}
                        className="no-result"
                      />
                      <p>No result found</p>
                    </Section>
                  )}
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing{' '}
                {listSupplierUsermanagement.length === 0
                  ? '0'
                  : formatNumberWithComma(
                      Math.min(
                        (responseGetSupplier.page - 1) *
                          responseGetSupplier.limit +
                          1
                      )
                    )}{' '}
                to{' '}
                {formatNumberWithComma(
                  Math.min(
                    responseGetSupplier.total_record,
                    responseGetSupplier.limit * responseGetSupplier.page
                  )
                )}{' '}
                of {formatNumberWithComma(responseGetSupplier.total_record)}{' '}
                entries
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={this.state.activePage}
                  itemsCountPerPage={this.state.responseGetSupplier.limit}
                  totalItemsCount={
                    this.state.responseGetSupplier.total_record || 0
                  }
                  // pageRangeDisplayed={this.state.responseGetSupplier.total_page}
                  onChange={pageNumber => this.onPageChange(pageNumber)}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                    value={this.state.searchPag}
                    onChange={e =>
                      this.setState({
                        searchPage: parseInt(e.target.value),
                      })
                    }
                  />

                  <Button
                    onClick={() => this.onPageChange(this.state.searchPage)}
                  >
                    go
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </UserManagementSupplierStyled>

        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>

          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {this.state.adminDetail.adminName}
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={() => this.toggleModal()}
            >
              Cancel
            </Button>

            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={() => this.checkTypeModal()}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    )
  }
}
const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}
export const UserManagementSupplierContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserManagementSupplier)
